import cf from './cf';
import c42v from './c42v_20211024';

export default class c42v1a extends c42v {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
//    this.class = this.constructor.name;
    this.class = 'c42v1a';
    this.d_viewDefs = {
      name: '権限設定'
    };
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

}
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
